import React from "react";

const CourseSuccessRate = ({courseRegistrationList}) => {
    if (!courseRegistrationList || courseRegistrationList.length === 0) {
        return <div className="CourseSuccessRate">Žádná data</div>;
    }

    const totalApplicants = courseRegistrationList.filter(req => req.isAlternate === false);
    const total = totalApplicants.length;
    const passedCount = courseRegistrationList.filter(reg => reg.passed).length;
    const failedCount = total - passedCount;
    const successRate = ((passedCount / total) * 100).toFixed(1); // 1 desetinné místo


    return (
        <div className="CourseSuccessRate">
            Úspěšnost: <strong>{total ? `${successRate}%` : '-'}</strong> |
            Úspěšně: <strong>{passedCount}</strong> |
            Neúspěšně: <strong>{failedCount}</strong>
        </div>
    );
};

export default CourseSuccessRate;
